// redux/features/unitSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiServices from "../../services/apiServices";

// Fetch units
export const fetchUnits = createAsyncThunk('units/fetchUnits', async () => {
  const response = await apiServices.get('units'); // Get units from API
  return response.data;
});

// Create unit
export const createUnit = createAsyncThunk('units/createUnit', async (unitData) => {
  const response = await apiServices.post('units', unitData); // Create a unit
  return response.data;
});

// Update unit
export const updateUnit = createAsyncThunk('units/updateUnit', async (unitData) => {
  const response = await apiServices.put(`units/${unitData.id}`, unitData); // Update unit
  return response.data;
});

// Delete unit
export const deleteUnit = createAsyncThunk('units/deleteUnit', async (id) => {
  await apiServices.delete(`units/${id}`); // Delete unit
  return id;
});

const unitSlice = createSlice({
  name: 'units',
  initialState: {
    units: [],
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUnits.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUnits.fulfilled, (state, action) => {
        state.loading = false;
        state.units = action.payload;
      })
      .addCase(fetchUnits.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createUnit.fulfilled, (state, action) => {
        state.units.push(action.payload);
      })
      .addCase(updateUnit.fulfilled, (state, action) => {
        const index = state.units.findIndex((unit) => unit._id === action.payload._id);
        if (index >= 0) {
          state.units[index] = action.payload;
        }
      })
      .addCase(deleteUnit.fulfilled, (state, action) => {
        state.units = state.units.filter((unit) => unit._id !== action.payload);
      });
  },
});

export default unitSlice.reducer;
